import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './en.json';
import zhTranslation from './zh.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      zh: { translation: zhTranslation }
    },
    lng: 'zh', // Set this to 'zh' to fix the "it should be Chinese" requirement
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;